import React from 'react';
import {Flex} from 'components';
import {size} from 'helpers';
import css from './gallery.module.scss';

export function Gallery({images}) {
  return size(images) > 0 && (
    <Flex className={css.gallery}>
      { images.map(image =>
        <figure key={image.id}>
          <img className={css.placeholder} src={image.url} />
          <img className={css.image} src={image.url} />
        </figure>
      ) }
    </Flex>
  );
}
